import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href", "title"];
const _hoisted_2 = {
    class: "col-10 p-0 text-left",
    style: { "hyphens": "auto" }
};
const _hoisted_3 = {
    key: 0,
    class: "col-2 numberMenu p-0"
};
const _hoisted_4 = { class: "bg-brand_deep_blue" };
const _hoisted_5 = {
    key: 1,
    class: "col-2 numberMenu p-0"
};
const _hoisted_6 = { class: "bg-brand_deep_blue" };
const _hoisted_7 = {
    key: 2,
    class: "col-2 numberMenu p-0"
};
const _hoisted_8 = { class: "bg-brand_deep_blue" };
import { computed } from 'vue';
import { useStore } from '@/store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MyAccountMenuItems',
    setup(__props) {
        const store = useStore();
        const accountNumbersRed = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.count_pending_sales; });
        const accountNumbersBlue = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.count_pending_purchases; });
        const accountNumbersWish = computed(() => { var _a, _b, _c; return (_b = (_a = store.state.account.wishlist) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : (_c = store.state.account.currentUser) === null || _c === void 0 ? void 0 : _c.count_wishlist; });
        const currentUrlPath = computed(() => {
            return location.pathname;
        });
        const myAccountMenuEntries = [
            {
                name: 'MEIN PROFIL',
                link: '/mein-account',
                trackingClass: 'track_myac_nav_profile',
                active: currentUrlPath.value === '/mein-account',
            },
            {
                name: 'ADRESSEN',
                link: '/mein-account/address',
                trackingClass: 'track_myac_nav_adress',
                active: currentUrlPath.value === '/mein-account/address',
            },
            {
                name: 'KONTODATEN',
                link: '/mein-account/bankAccounts',
                trackingClass: 'track_myac_nav_payments',
                active: currentUrlPath.value === '/mein-account/bankAccounts',
            },
            {
                name: 'MEINE VERKÄUFE',
                link: '/mein-account/transactions/sales',
                trackingClass: 'track_myac_nav_red_orders',
                active: currentUrlPath.value === '/mein-account/transactions/sales',
            },
            {
                name: 'MEINE KÄUFE',
                link: '/mein-account/transactions/purchases',
                trackingClass: 'track_myac_nav_blue_orders',
                active: currentUrlPath.value === '/mein-account/transactions/purchases',
            },
            {
                name: 'WUNSCHZETTEL',
                link: '/mein-account/wishlist',
                trackingClass: 'track_myac_nav_wishlist',
                active: currentUrlPath.value === '/mein-account/wishlist',
            },
            {
                name: 'FREUNDE WERBEN',
                link: '/freunde-werben',
                trackingClass: 'track_myac_nav_freunde_werben',
                active: currentUrlPath.value === '/freunde-werben',
            },
            {
                name: 'ABMELDEN',
                link: '/logout',
                trackingClass: 'track_myac_nav_logout',
                active: false,
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, _renderList(myAccountMenuEntries, (e, i) => {
                return _createElementVNode("li", {
                    key: i,
                    class: _normalizeClass(["col-12 py-2", [{ active: e.active }, e.trackingClass]])
                }, [
                    _createElementVNode("a", {
                        class: "row",
                        href: e.link,
                        title: e.name
                    }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(e.name), 1),
                        (e.name === 'MEINE VERKÄUFE' && accountNumbersRed.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(accountNumbersRed.value), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (e.name === 'MEINE KÄUFE' && accountNumbersBlue.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(accountNumbersBlue.value), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (e.name === 'WUNSCHZETTEL' && accountNumbersWish.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(accountNumbersWish.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_1)
                ], 2);
            }), 64));
        };
    }
});
